export default __webpack_public_path__ + "static/media/kb.534b85d8.png";